var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
// import AF from './flags/AF';
// import AI from './flags/AI';
// import AQ from './flags/AQ';
// import AS from './flags/AS';
// import AX from './flags/AX';
// import BL from './flags/BL';
// import BM from './flags/BM';
// import BQ from './flags/BQ';
// import BS from './flags/BS';
// import BT from './flags/BT';
// import BV from './flags/BV';
// import BZ from './flags/BZ';
// import CC from './flags/CC';
// import CK from './flags/CK';
// import CW from './flags/CW';
//import DE from './flags/DE';
// import EC from './flags/EC';
// import FK from './flags/FK';
// import FO from './flags/FO';
// import GF from './flags/GF';
// import GG from './flags/GG';
// import GI from './flags/GI';
// import GL from './flags/GL';
// import GP from './flags/GP';
// import GS from './flags/GS';
// import GT from './flags/GT';
// import GU from './flags/GU';
// import HK from './flags/HK';
// import HM from './flags/HM';
// import IM from './flags/IM';
// import IO from './flags/IO';
// import JE from './flags/JE';
// import KY from './flags/KY';
// import MF from './flags/MF';
// import MP from './flags/MP';
// import MQ from './flags/MQ';
// import MS from './flags/MS';
// import MX from './flags/MX';
// import NC from './flags/NC';
// import NI from './flags/NI';
// import NU from './flags/NU';
// import PA from './flags/PA';
// import PF from './flags/PF';
// import PM from './flags/PM';
// import PN from './flags/PN';
// import PT from './flags/PT';
// import RE from './flags/RE';
//import RS from './flags/RS';
// import SH from './flags/SH';
// import SJ from './flags/SJ';
// import SM from './flags/SM';
// import SV from './flags/SV';
// import SX from './flags/SX';
// import SZ from './flags/SZ';
// import TC from './flags/TC';
// import TF from './flags/TF';
// import TL from './flags/TL';
// import UM from './flags/UM';
// import VA from './flags/VA';
// import VG from './flags/VG';
// import VI from './flags/VI';
// import WF from './flags/WF';
// import YT from './flags/YT';
var WaitingComponent = function (Component) {
    return function (props) { return (React.createElement(React.Suspense, { fallback: React.createElement("div", null) },
        React.createElement(Component, __assign({}, props)))); };
};
var AD = WaitingComponent(React.lazy(function () { return import('./flags/AD'); }));
var AE = WaitingComponent(React.lazy(function () { return import('./flags/AE'); }));
var AG = WaitingComponent(React.lazy(function () { return import('./flags/AG'); }));
var AL = WaitingComponent(React.lazy(function () { return import('./flags/AL'); }));
var AM = WaitingComponent(React.lazy(function () { return import('./flags/AM'); }));
var AO = WaitingComponent(React.lazy(function () { return import('./flags/AO'); }));
var AR = WaitingComponent(React.lazy(function () { return import('./flags/AR'); }));
var AT = WaitingComponent(React.lazy(function () { return import('./flags/AT'); }));
var AU = WaitingComponent(React.lazy(function () { return import('./flags/AU'); }));
var AW = WaitingComponent(React.lazy(function () { return import('./flags/AW'); }));
var AZ = WaitingComponent(React.lazy(function () { return import('./flags/AZ'); }));
var BA = WaitingComponent(React.lazy(function () { return import('./flags/BA'); }));
var BB = WaitingComponent(React.lazy(function () { return import('./flags/BB'); }));
var BD = WaitingComponent(React.lazy(function () { return import('./flags/BD'); }));
var BE = WaitingComponent(React.lazy(function () { return import('./flags/BE'); }));
var BF = WaitingComponent(React.lazy(function () { return import('./flags/BF'); }));
var BG = WaitingComponent(React.lazy(function () { return import('./flags/BG'); }));
var BH = WaitingComponent(React.lazy(function () { return import('./flags/BH'); }));
var BI = WaitingComponent(React.lazy(function () { return import('./flags/BI'); }));
var BJ = WaitingComponent(React.lazy(function () { return import('./flags/BJ'); }));
var BN = WaitingComponent(React.lazy(function () { return import('./flags/BN'); }));
var BO = WaitingComponent(React.lazy(function () { return import('./flags/BO'); }));
var BR = WaitingComponent(React.lazy(function () { return import('./flags/BR'); }));
var BW = WaitingComponent(React.lazy(function () { return import('./flags/BW'); }));
var BY = WaitingComponent(React.lazy(function () { return import('./flags/BY'); }));
var CA = WaitingComponent(React.lazy(function () { return import('./flags/CA'); }));
var CD = WaitingComponent(React.lazy(function () { return import('./flags/CD'); }));
var CF = WaitingComponent(React.lazy(function () { return import('./flags/CF'); }));
var CG = WaitingComponent(React.lazy(function () { return import('./flags/CG'); }));
var CH = WaitingComponent(React.lazy(function () { return import('./flags/CH'); }));
var CI = WaitingComponent(React.lazy(function () { return import('./flags/CI'); }));
var CL = WaitingComponent(React.lazy(function () { return import('./flags/CL'); }));
var CM = WaitingComponent(React.lazy(function () { return import('./flags/CM'); }));
var CN = WaitingComponent(React.lazy(function () { return import('./flags/CN'); }));
var CO = WaitingComponent(React.lazy(function () { return import('./flags/CO'); }));
var CR = WaitingComponent(React.lazy(function () { return import('./flags/CR'); }));
var CU = WaitingComponent(React.lazy(function () { return import('./flags/CU'); }));
var CV = WaitingComponent(React.lazy(function () { return import('./flags/CV'); }));
var CX = WaitingComponent(React.lazy(function () { return import('./flags/CX'); }));
var CY = WaitingComponent(React.lazy(function () { return import('./flags/CY'); }));
var CZ = WaitingComponent(React.lazy(function () { return import('./flags/CZ'); }));
var DJ = WaitingComponent(React.lazy(function () { return import('./flags/DJ'); }));
var DK = WaitingComponent(React.lazy(function () { return import('./flags/DK'); }));
var DM = WaitingComponent(React.lazy(function () { return import('./flags/DM'); }));
var DO = WaitingComponent(React.lazy(function () { return import('./flags/DO'); }));
var DZ = WaitingComponent(React.lazy(function () { return import('./flags/DZ'); }));
var EE = WaitingComponent(React.lazy(function () { return import('./flags/EE'); }));
var EG = WaitingComponent(React.lazy(function () { return import('./flags/EG'); }));
var EH = WaitingComponent(React.lazy(function () { return import('./flags/EH'); }));
var ER = WaitingComponent(React.lazy(function () { return import('./flags/ER'); }));
var ES = WaitingComponent(React.lazy(function () { return import('./flags/ES'); }));
var ET = WaitingComponent(React.lazy(function () { return import('./flags/ET'); }));
var FI = WaitingComponent(React.lazy(function () { return import('./flags/FI'); }));
var FJ = WaitingComponent(React.lazy(function () { return import('./flags/FJ'); }));
var FM = WaitingComponent(React.lazy(function () { return import('./flags/FM'); }));
var FR = WaitingComponent(React.lazy(function () { return import('./flags/FR'); }));
var GA = WaitingComponent(React.lazy(function () { return import('./flags/GA'); }));
var GB = WaitingComponent(React.lazy(function () { return import('./flags/GB'); }));
var GD = WaitingComponent(React.lazy(function () { return import('./flags/GD'); }));
var GE = WaitingComponent(React.lazy(function () { return import('./flags/GE'); }));
var GH = WaitingComponent(React.lazy(function () { return import('./flags/GH'); }));
var GM = WaitingComponent(React.lazy(function () { return import('./flags/GM'); }));
var GN = WaitingComponent(React.lazy(function () { return import('./flags/GN'); }));
var GQ = WaitingComponent(React.lazy(function () { return import('./flags/GQ'); }));
var GR = WaitingComponent(React.lazy(function () { return import('./flags/GR'); }));
var GW = WaitingComponent(React.lazy(function () { return import('./flags/GW'); }));
var GY = WaitingComponent(React.lazy(function () { return import('./flags/GY'); }));
var HN = WaitingComponent(React.lazy(function () { return import('./flags/HN'); }));
var HR = WaitingComponent(React.lazy(function () { return import('./flags/HR'); }));
var HT = WaitingComponent(React.lazy(function () { return import('./flags/HT'); }));
var HU = WaitingComponent(React.lazy(function () { return import('./flags/HU'); }));
var ID = WaitingComponent(React.lazy(function () { return import('./flags/ID'); }));
var IE = WaitingComponent(React.lazy(function () { return import('./flags/IE'); }));
var IL = WaitingComponent(React.lazy(function () { return import('./flags/IL'); }));
var IN = WaitingComponent(React.lazy(function () { return import('./flags/IN'); }));
var IQ = WaitingComponent(React.lazy(function () { return import('./flags/IQ'); }));
var IR = WaitingComponent(React.lazy(function () { return import('./flags/IR'); }));
var IS = WaitingComponent(React.lazy(function () { return import('./flags/IS'); }));
var IT = WaitingComponent(React.lazy(function () { return import('./flags/IT'); }));
var JM = WaitingComponent(React.lazy(function () { return import('./flags/JM'); }));
var JO = WaitingComponent(React.lazy(function () { return import('./flags/JO'); }));
var JP = WaitingComponent(React.lazy(function () { return import('./flags/JP'); }));
var KE = WaitingComponent(React.lazy(function () { return import('./flags/KE'); }));
var KG = WaitingComponent(React.lazy(function () { return import('./flags/KG'); }));
var KH = WaitingComponent(React.lazy(function () { return import('./flags/KH'); }));
var KI = WaitingComponent(React.lazy(function () { return import('./flags/KI'); }));
var KM = WaitingComponent(React.lazy(function () { return import('./flags/KM'); }));
var KN = WaitingComponent(React.lazy(function () { return import('./flags/KN'); }));
var KP = WaitingComponent(React.lazy(function () { return import('./flags/KP'); }));
var KR = WaitingComponent(React.lazy(function () { return import('./flags/KR'); }));
var KW = WaitingComponent(React.lazy(function () { return import('./flags/KW'); }));
var KZ = WaitingComponent(React.lazy(function () { return import('./flags/KZ'); }));
var LA = WaitingComponent(React.lazy(function () { return import('./flags/LA'); }));
var LB = WaitingComponent(React.lazy(function () { return import('./flags/LB'); }));
var LC = WaitingComponent(React.lazy(function () { return import('./flags/LC'); }));
var LI = WaitingComponent(React.lazy(function () { return import('./flags/LI'); }));
var LK = WaitingComponent(React.lazy(function () { return import('./flags/LK'); }));
var LR = WaitingComponent(React.lazy(function () { return import('./flags/LR'); }));
var LS = WaitingComponent(React.lazy(function () { return import('./flags/LS'); }));
var LT = WaitingComponent(React.lazy(function () { return import('./flags/LT'); }));
var LU = WaitingComponent(React.lazy(function () { return import('./flags/LU'); }));
var LV = WaitingComponent(React.lazy(function () { return import('./flags/LV'); }));
var LY = WaitingComponent(React.lazy(function () { return import('./flags/LY'); }));
var MA = WaitingComponent(React.lazy(function () { return import('./flags/MA'); }));
var MC = WaitingComponent(React.lazy(function () { return import('./flags/MC'); }));
var MD = WaitingComponent(React.lazy(function () { return import('./flags/MD'); }));
var ME = WaitingComponent(React.lazy(function () { return import('./flags/ME'); }));
var MG = WaitingComponent(React.lazy(function () { return import('./flags/MG'); }));
var MH = WaitingComponent(React.lazy(function () { return import('./flags/MH'); }));
var MK = WaitingComponent(React.lazy(function () { return import('./flags/MK'); }));
var ML = WaitingComponent(React.lazy(function () { return import('./flags/ML'); }));
var MM = WaitingComponent(React.lazy(function () { return import('./flags/MM'); }));
var MN = WaitingComponent(React.lazy(function () { return import('./flags/MN'); }));
var MO = WaitingComponent(React.lazy(function () { return import('./flags/MO'); }));
var MR = WaitingComponent(React.lazy(function () { return import('./flags/MR'); }));
var MT = WaitingComponent(React.lazy(function () { return import('./flags/MT'); }));
var MU = WaitingComponent(React.lazy(function () { return import('./flags/MU'); }));
var MV = WaitingComponent(React.lazy(function () { return import('./flags/MV'); }));
var MW = WaitingComponent(React.lazy(function () { return import('./flags/MW'); }));
var MY = WaitingComponent(React.lazy(function () { return import('./flags/MY'); }));
var MZ = WaitingComponent(React.lazy(function () { return import('./flags/MZ'); }));
var NA = WaitingComponent(React.lazy(function () { return import('./flags/NA'); }));
var NE = WaitingComponent(React.lazy(function () { return import('./flags/NE'); }));
var NF = WaitingComponent(React.lazy(function () { return import('./flags/NF'); }));
var NG = WaitingComponent(React.lazy(function () { return import('./flags/NG'); }));
var NL = WaitingComponent(React.lazy(function () { return import('./flags/NL'); }));
var NO = WaitingComponent(React.lazy(function () { return import('./flags/NO'); }));
var NP = WaitingComponent(React.lazy(function () { return import('./flags/NP'); }));
var NR = WaitingComponent(React.lazy(function () { return import('./flags/NR'); }));
var NZ = WaitingComponent(React.lazy(function () { return import('./flags/NZ'); }));
var OM = WaitingComponent(React.lazy(function () { return import('./flags/OM'); }));
var PE = WaitingComponent(React.lazy(function () { return import('./flags/PE'); }));
var PG = WaitingComponent(React.lazy(function () { return import('./flags/PG'); }));
var PH = WaitingComponent(React.lazy(function () { return import('./flags/PH'); }));
var PK = WaitingComponent(React.lazy(function () { return import('./flags/PK'); }));
var PL = WaitingComponent(React.lazy(function () { return import('./flags/PL'); }));
var PR = WaitingComponent(React.lazy(function () { return import('./flags/PR'); }));
var PS = WaitingComponent(React.lazy(function () { return import('./flags/PS'); }));
var PW = WaitingComponent(React.lazy(function () { return import('./flags/PW'); }));
var PY = WaitingComponent(React.lazy(function () { return import('./flags/PY'); }));
var QA = WaitingComponent(React.lazy(function () { return import('./flags/QA'); }));
var RO = WaitingComponent(React.lazy(function () { return import('./flags/RO'); }));
var RU = WaitingComponent(React.lazy(function () { return import('./flags/RU'); }));
var RW = WaitingComponent(React.lazy(function () { return import('./flags/RW'); }));
var SA = WaitingComponent(React.lazy(function () { return import('./flags/SA'); }));
var SB = WaitingComponent(React.lazy(function () { return import('./flags/SB'); }));
var SC = WaitingComponent(React.lazy(function () { return import('./flags/SC'); }));
var SD = WaitingComponent(React.lazy(function () { return import('./flags/SD'); }));
var SE = WaitingComponent(React.lazy(function () { return import('./flags/SE'); }));
var SG = WaitingComponent(React.lazy(function () { return import('./flags/SG'); }));
var SI = WaitingComponent(React.lazy(function () { return import('./flags/SI'); }));
var SK = WaitingComponent(React.lazy(function () { return import('./flags/SK'); }));
var SL = WaitingComponent(React.lazy(function () { return import('./flags/SL'); }));
var SN = WaitingComponent(React.lazy(function () { return import('./flags/SN'); }));
var SO = WaitingComponent(React.lazy(function () { return import('./flags/SO'); }));
var SR = WaitingComponent(React.lazy(function () { return import('./flags/SR'); }));
var SS = WaitingComponent(React.lazy(function () { return import('./flags/SS'); }));
var ST = WaitingComponent(React.lazy(function () { return import('./flags/ST'); }));
var SY = WaitingComponent(React.lazy(function () { return import('./flags/SY'); }));
var TD = WaitingComponent(React.lazy(function () { return import('./flags/TD'); }));
var TG = WaitingComponent(React.lazy(function () { return import('./flags/TG'); }));
var TH = WaitingComponent(React.lazy(function () { return import('./flags/TH'); }));
var TJ = WaitingComponent(React.lazy(function () { return import('./flags/TJ'); }));
var TK = WaitingComponent(React.lazy(function () { return import('./flags/TK'); }));
var TM = WaitingComponent(React.lazy(function () { return import('./flags/TM'); }));
var TN = WaitingComponent(React.lazy(function () { return import('./flags/TN'); }));
var TO = WaitingComponent(React.lazy(function () { return import('./flags/TO'); }));
var TR = WaitingComponent(React.lazy(function () { return import('./flags/TR'); }));
var TT = WaitingComponent(React.lazy(function () { return import('./flags/TT'); }));
var TV = WaitingComponent(React.lazy(function () { return import('./flags/TV'); }));
var TW = WaitingComponent(React.lazy(function () { return import('./flags/TW'); }));
var TZ = WaitingComponent(React.lazy(function () { return import('./flags/TZ'); }));
var UA = WaitingComponent(React.lazy(function () { return import('./flags/UA'); }));
var UG = WaitingComponent(React.lazy(function () { return import('./flags/UG'); }));
var US = WaitingComponent(React.lazy(function () { return import('./flags/US'); }));
var UY = WaitingComponent(React.lazy(function () { return import('./flags/UY'); }));
var UZ = WaitingComponent(React.lazy(function () { return import('./flags/UZ'); }));
var VC = WaitingComponent(React.lazy(function () { return import('./flags/VC'); }));
var VE = WaitingComponent(React.lazy(function () { return import('./flags/VE'); }));
var VN = WaitingComponent(React.lazy(function () { return import('./flags/VN'); }));
var VU = WaitingComponent(React.lazy(function () { return import('./flags/VU'); }));
var WS = WaitingComponent(React.lazy(function () { return import('./flags/WS'); }));
var YE = WaitingComponent(React.lazy(function () { return import('./flags/YE'); }));
var ZA = WaitingComponent(React.lazy(function () { return import('./flags/ZA'); }));
var ZM = WaitingComponent(React.lazy(function () { return import('./flags/ZM'); }));
var BZ_2 = WaitingComponent(React.lazy(function () { return import('./flags/BZ'); }));
var RS = WaitingComponent(React.lazy(function () { return import("./flags/RS"); }));
var DE = WaitingComponent(React.lazy(function () { return import("./flags/DE"); }));
var HoverFlag = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: ", ";\n  display: inline-block;\n  margin-right: 2px;\n  margin-left: 2px;\n  transition: all 0.2s ease-in-out;\n  transform: scale(1);\n  &:hover{\n    transform: ", ";\n  }\n"], ["\n  cursor: ", ";\n  display: inline-block;\n  margin-right: 2px;\n  margin-left: 2px;\n  transition: all 0.2s ease-in-out;\n  transform: scale(1);\n  &:hover{\n    transform: ", ";\n  }\n"])), function (p) { return p.hoverable ? "pointer" : "default"; }, function (props) { return props.hoverable ? "scale(1.4)" : "scale(1.0)"; });
var Flag = React.memo(function (props) {
    var hoverable = props.hoverable, name = props.name, rest = __rest(props, ["hoverable", "name"]);
    var code = getISO_3166From(name);
    var F = FlagDefinitions[code];
    if (F)
        return (React.createElement(HoverFlag, { hoverable: hoverable },
            React.createElement(F, __assign({}, rest))));
    console.log("Flag not implemented");
    return null;
});
export default Flag;
export var FlagDefinitions = {
    "AD": AD, "AE": AE, "AG": AG, "AL": AL, "AM": AM, "AO": AO, "AR": AR, "AT": AT, "AU": AU, "AW": AW, "AZ": AZ, "BA": BA, "BB": BB, "BD": BD, "BE": BE, "BF": BF, "BG": BG, "BH": BH, "BI": BI, "BJ": BJ, "BN": BN, "BO": BO, "BR": BR, "BW": BW, "BY": BY, "CA": CA, "CD": CD, "CF": CF, "CG": CG, "CH": CH, "CI": CI, "CL": CL, "CM": CM, "CN": CN, "CO": CO, "CR": CR, "CU": CU, "CV": CV, "CX": CX, "CY": CY, "CZ": CZ, "DE": DE, "DJ": DJ, "DK": DK, "DM": DM, "DO": DO, "DZ": DZ, "EE": EE, "EG": EG, "EH": EH, "ER": ER, "ES": ES, "ET": ET, "FI": FI, "FJ": FJ, "FM": FM, "FR": FR, "GA": GA, "GB": GB, "GD": GD, "GE": GE, "GH": GH, "GM": GM, "GN": GN, "GQ": GQ, "GR": GR, "GW": GW, "GY": GY, "HN": HN, "HR": HR, "HT": HT, "HU": HU, "ID": ID, "IE": IE, "IL": IL, "IN": IN, "IQ": IQ, "IR": IR, "IS": IS, "IT": IT, "JM": JM, "JO": JO, "JP": JP, "KE": KE, "KG": KG, "KH": KH, "KI": KI, "KM": KM, "KN": KN, "KP": KP, "KR": KR, "KW": KW, "KZ": KZ, "LA": LA, "LB": LB, "LC": LC, "LI": LI, "LK": LK, "LR": LR, "LS": LS, "LT": LT, "LU": LU, "LV": LV, "LY": LY, "MA": MA, "MC": MC, "MD": MD, "ME": ME, "MG": MG, "MH": MH, "MK": MK, "ML": ML, "MM": MM, "MN": MN, "MO": MO, "MR": MR, "MT": MT, "MU": MU, "MV": MV, "MW": MW, "MY": MY, "MZ": MZ, "NA": NA, "NE": NE, "NF": NF, "NG": NG, "NL": NL, "NO": NO, "NP": NP, "NR": NR, "NZ": NZ, "OM": OM, "PE": PE, "PG": PG, "PH": PH, "PK": PK, "PL": PL, "PR": PR, "PS": PS, "PW": PW, "PY": PY, "QA": QA, "RO": RO, "RS": RS, "RU": RU, "RW": RW, "SA": SA, "SB": SB, "SC": SC, "SD": SD, "SE": SE, "SG": SG, "SI": SI, "SK": SK, "SL": SL, "SN": SN, "SO": SO, "SR": SR, "SS": SS, "ST": ST, "SY": SY, "TD": TD, "TG": TG, "TH": TH, "TJ": TJ, "TK": TK, "TM": TM, "TN": TN, "TO": TO, "TR": TR, "TT": TT, "TV": TV, "TW": TW, "TZ": TZ, "UA": UA, "UG": UG, "US": US, "UY": UY, "UZ": UZ, "VC": VC, "VE": VE, "VN": VN, "VU": VU, "WS": WS, "YE": YE, "ZA": ZA, "ZM": ZM, "BZ": BZ_2
};
export function getISO_3166FromRFC_4646(code) {
    var subtags = code.split("-"); //[0]: ISO_639, [1] ISO_3166, [2] ISO_15924
    if (subtags.length < 2)
        throw new Error("No nationality given \"" + code + "\"");
    return subtags[1];
}
export function getISO_3166From(name) {
    if (name.length === 2 && isUpperCase(name.charAt(0)) && isUpperCase(name.charAt(1)))
        return name;
    return getISO_3166FromRFC_4646(name);
}
export function isUpperCase(c) {
    return c.toLocaleUpperCase() === c;
}
export var getCountryFlag = function (lng) {
    var flag = undefined;
    lng.replace("_", "-");
    if (lng.indexOf("-") > 0)
        flag = lng.split("-")[1].toUpperCase();
    else
        flag = lng.toUpperCase();
    return FlagDefinitions[flag] ? flag : undefined;
};
export var languages = ["af", "af-ZA", "ar", "ar-AE", "ar-BH", "ar-DZ", "ar-EG", "ar-IQ", "ar-JO", "ar-KW", "ar-LB", "ar-LY", "ar-MA", "ar-OM", "ar-QA", "ar-SA", "ar-SY", "ar-TN", "ar-YE", "az", "az-AZ", "az-AZ-Latn", "be", "be-BY", "bg", "bg-BG", "ca", "ca-ES", "cs", "cs-CZ", "da", "da-DK", "de", "de-AT", "de-CH", "de-DE", "de-LI", "de-LU", "div", "div-MV", "el", "el-GR", "en", "en-AU", "en-BZ", "en-CA", "en-CB", "en-GB", "en-IE", "en-JM", "en-NZ", "en-PH", "en-TT", "en-US", "en-ZA", "en-ZW", "es", "es-AR", "es-BO", "es-CLe", "es-CO", "es-CR", "es-DO", "es-EC", "es-ES", "es-GT", "es-HN", "es-MX", "es-NI", "es-PA", "es-PE", "es-PR", "es-PY", "es-SV", "es-UY", "es-VE", "et", "et-EE", "eu", "eu-ES", "fa", "fa-IR", "fi", "fi-FI", "fo", "fo-FO", "fr", "fr-BE", "fr-CA", "fr-CH", "fr-FR", "fr-LU", "fr-MC", "gl", "gl-ES", "gu", "gu-IN", "he", "he-IL", "hi", "hi-IN", "hr", "hr-HR", "hu", "hu-HU", "hy", "hy-AM", "id", "id-ID", "is", "is-IS", "it", "it-CH", "it-IT", "ja", "ja-JP", "ka", "ka-GE", "kk", "kk-KZ", "kn", "kn-IN", "ko", "kok", "kok-IN", "ko-KR", "ky", "ky-KG", "lt", "lt-LT", "lv", "lv-LV", "mk", "mk-MK", "mn", "mn-MN", "mr", "mr-IN", "ms", "ms-BN", "ms-MY", "nb-NO", "nl", "nl-BE", "nl-NL", "nn-NO", "no", "pa", "pa-IN", "pl", "pl-PL", "pt", "pt-BR", "pt-PT", "ro", "ro-RO", "ru", "ru-RU", "sa", "sa-IN", "sk", "sk-SK", "sl", "sl-SI", "sq", "sq-AL", "sr-SP-Cyrl", "sr-SP-Latn", "sv", "sv-FI", "sv-SE", "sw", "sw-KE", "syr", "syr-SY", "ta", "ta-IN", "te", "te-IN", "th", "th-TH", "tr", "tr-TR", "tt", "tt-RU", "uk", "uk-UA", "ur", "ur-PK", "uz", "uz-UZ-Cyrl", "uz-UZ-Latn", "vi", "zh-CHT", "zh-CHS", "zh-CN", "zh-HK", "zh-MO", "zh-SG", "zh-TW"];
var templateObject_1;
//# sourceMappingURL=Flag.js.map